import { render, staticRenderFns } from "./BucketIssueBody.vue?vue&type=template&id=6e71f250&scoped=true"
import script from "./BucketIssueBody.vue?vue&type=script&lang=js"
export * from "./BucketIssueBody.vue?vue&type=script&lang=js"
import style0 from "./BucketIssueBody.vue?vue&type=style&index=0&id=6e71f250&prod&lang=scss&scoped=true"
import style1 from "./BucketIssueBody.vue?vue&type=style&index=1&id=6e71f250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71f250",
  null
  
)

export default component.exports